import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchResponseDTO } from '@dtos/hotel.dto';
import { SearchPayload, SearchResponse } from '@models/hotel';
import { BaseRepository } from '@repos/base.repository';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

// TODO remove this provide in root
@Injectable({
 providedIn: 'root',
})
export class PLPRepository extends BaseRepository {
 getHotels(
  requestBody: Partial<SearchPayload>,
  dynamicsearchfilter: string,
  accomodation: string
 ): Observable<SearchResponse> {
   const url =
     this.baseUrl +
     (accomodation == 'ecolodge' || accomodation == 'villa-mashhad'
       ? 'v1/accomodation/filter'
       : !dynamicsearchfilter || dynamicsearchfilter?.split('-')[1] == 'stars'
         ? 'v1/search/filter'
         : 'v1/search/dynamicSearchFilter');

  const {
   HotelId,
   StateId,
   CityId,
   RegionId,
   SearchQuery,
   StartDate,
   EndDate,
   ReferUrl,
   DistrictId,
   ...rest
  } = requestBody;

  let params = new HttpParams();
  let stringParams = '?';

  for (const [key, value] of Object.entries(requestBody)) {
   if (requestBody.hasOwnProperty(key)) {
    params = params.append(key, String(value));
    stringParams = `${stringParams}${key}=${String(value)}&`;
   }
  }


  

  const requestHeader = {
   ...params,
   DynamicPageUrl: true,
   observe: 'response',
   responseType: 'json',
   headers: new HttpHeaders({
    Accept: 'application/json',
   }),
   //  withCredentials: true,
  };
  // return this.get<SearchResponseDTO>(url, false, requestHeader)
  const plpIsValid = stringParams.split('&').some((key) => {
   return (
    key.split('=')[0].toLowerCase() == 'cityname' &&
    ![undefined, '', null].includes(key.split('=')[1])
   );
  });

  return this.get<SearchResponseDTO>(
   url +
    (dynamicsearchfilter?.split('-')[1] == 'stars'
     ? stringParams + `grades=${dynamicsearchfilter?.split('-')[0]}`
     : dynamicsearchfilter?.split('-')[1] == 'rec'
     ? stringParams + `DynamicPageUrl=${dynamicsearchfilter}`
     : stringParams)
  ).pipe(
   map((res: SearchResponseDTO) => {
    let {
     Cards,
     PageTitle,
     MapUrl,
     ShowBanner,
     FilterBar,
     HashKey,
     FAQs,
     Search,
     Breadcrumb,
     OtherHotels,
     PageGeneratorLinks,
     PopularHotels,
     ShabIndex,
    } = res;

    return {
     Cards,
     PageTitle,
     MapUrl,
     ShowBanner,
     FilterBar,
     HashKey,
     FAQs,
     OtherHotels,
     PageGeneratorLinks,
     PopularHotels,
     Search,
     Breadcrumb,
     ShabIndex,
    } as SearchResponse;
   })
  );
 }
}
